/**
 * Core functionalities that are needed throughout the site
 */

import './polyfills'; // Apply polyfills
import branchBar from './branch-bar';
import btn from './btn';
import hero from './hero';
import { initDonationElements } from './donation';
import formHelper from './form-helper';
import formMailingList from './form-mailing-list';
import modals from './modal';
import languageMenu from './language-menu';
import nav from './nav';
import parallax from './parallax';
import stickyfill from 'stickyfilljs';
import './collapsible';
import tabbed from './tabbed';
import cookiePopup from './cookie-popup';
import './countdown';
import LinkWrappers from './link-wrappers';
import searchSelects from './select-search';
import './donation-tiers';

if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production' || process.env.SW_DEV) {
    const serviceWorkerPath = `${process.env.PUBLIC_PATH}service-worker.js`;
    navigator.serviceWorker
      .register(serviceWorkerPath, { scope: '/' })
      .then(function() {
        // registration worked
        console.log('Service worker registered.');
      })
      .catch(function(error) {
        // If there is (probably) something wrong with Service Worker path
        if (error instanceof TypeError) {
          // registration failed
          console.log(
            `Service worker registration failed. Invalid Service Worker path? (${serviceWorkerPath})`
          );
        }
      });
  }
}

// Detect when user touches screen
window.addEventListener('touchstart', function onFirstTouch() {
  // Add class to `html`
  document.documentElement.classList.add('has-touched');

  window.removeEventListener('touchstart', onFirstTouch, false);
}, false);

nav.init();
languageMenu.init();

// Forms
formHelper.initForms();
formMailingList.initForms();
searchSelects.initMultiple(Array.from(document.querySelectorAll('.js-select-search')));

// Init donation functionality
initDonationElements();

// Init elements that use ripple animation
btn.initRipple('.btn');
btn.initRipple('.js-ripple', '.js-ripple__layer');

// Init hero
hero.init();

// Init parallaxes
parallax.init('.js-parallax');

// Init branch selector
branchBar.init();

// Modals
modals.init();

tabbed.init();
cookiePopup.init();

const linkWrappers = new LinkWrappers();
linkWrappers.attachListeners();

// Enable `position: sticky` in older browsers. You still need to add proper sticky styles to element
const stickyElement = document.querySelectorAll('.js-sticky');
stickyfill.add(stickyElement);

// Remove loading class from <html>
document.documentElement.classList.remove('loading');
